import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';

export default [
    {
        path: '/check/:participationId?',
        name: ROUTE_NAME.CHECK,
        meta: {
            title: '审核打卡',
            needLogin: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "check" */ '@/pages/check/check.vue'),
            loading: Loading,
        }),
    },
];
